export default __webpack_public_path__ + "img/Smart-Infrastructure-Services.d52b2560.png";